<p-table #recursiveTable tableLayout="fixed" class="recursive-table" [ngClass]="tableInfo().type === 'nested-alt' ? 'nested-alt' : ''" [value]="data()" dataKey="id" [scrollable]="true" [size]="'small'" [rowExpandMode]="'multiple'">
    <!-- ===== HEADER ===== -->
    @if (tableInfo().type === 'nested-alt') {
        @if (enableStickyCols) {
            <ng-template pTemplate="header">
                <tr>
                    <!-- @if (tableInfo().type === 'nested' || tableInfo().type === 'nested-alt') {
                    <th pFrozenColumn></th>
                    } -->
            
                    <!-- @if (tableInfo().showCheckbox || tableInfo().showIcon !== 'none') {
                    <th pFrozenColumn [style.width]="'116px'">
                        @if (tableInfo().showCheckbox) {
                        <p-checkbox [(ngModel)]="someChecked" binary="true" (onChange)="onCheckboxAllChange($event)">
                            <ng-template pTemplate="checkboxicon" let-checked>
                                @if (someChecked) {
                                <i class="pi pi-minus"></i>
                                }
                            </ng-template>
                        </p-checkbox>
                        }
                    </th>
                    } -->
            
                    @for(column of tableInfo().columns; track column) {
                        @if(!column.hide && !column.customizeHide) {
                            @if(column.sticky) {
                                <th pFrozenColumn>
                                    <div class="flex gap-2 align-items-center">
                                        <span>{{ (column.header | translate: buildHeaderParams(column) ) | uppercase }}</span>
                                        @if (column.headerConfig && column.headerConfig.showInfoTooltip) {
                                            <i class="icon info-icon" pTooltip="{{column.headerConfig.infoTooltipText | translate}}"></i>
                                        }
                                    </div>
                                </th>
                            } @else {
                                <th>
                                    <div class="flex gap-2 align-items-center">
                                        <span>{{ (column.header | translate: buildHeaderParams(column) ) | uppercase }}</span>
                                        @if (column.headerConfig && column.headerConfig.showInfoTooltip) {
                                            <i class="icon info-icon" pTooltip="{{column.headerConfig.infoTooltipText | translate}}"></i>
                                        }
                                    </div>
                                </th>
                            }
                        }
                    }
                </tr>
            </ng-template>
        }
        @else {
            <ng-template pTemplate="header">
                <tr>
                    <!-- @if (tableInfo().type === 'nested' || tableInfo().type === 'nested-alt') {
                    <th></th>
                    } -->
            
                    <!-- @if (tableInfo().showCheckbox || tableInfo().showIcon !== 'none') {
                        <th [style.width]="'116px'">
                            @if (tableInfo().showCheckbox) {
                            <p-checkbox [(ngModel)]="someChecked" binary="true" (onChange)="onCheckboxAllChange($event)">
                                <ng-template pTemplate="checkboxicon" let-checked>
                                    @if (someChecked) {
                                    <i class="pi pi-minus"></i>
                                    }
                                </ng-template>
                            </p-checkbox>
                            }
                        </th>
                    } -->
            
                    @for(column of tableInfo().columns; track column) {
                        @if(!column.hide && !column.customizeHide) {
                            <th>
                                <div class="flex gap-2 align-items-center">
                                    <span>{{ (column.header | translate) | uppercase }}</span>
                                    @if (column.headerConfig && column.headerConfig.showInfoTooltip) {
                                        <i class="icon info-icon" pTooltip="{{column.headerConfig.infoTooltipText | translate}}"></i>
                                    }
                                </div>
                            </th>
                        }
                    }
                </tr>
            </ng-template>
        }
    }

    <ng-template pTemplate="colgroup">
        <colgroup>
            <!-- Expand arrow column -->
            @if (tableInfo().type !== 'nested-alt') {
                <col style="width: 62px" />
            }
            
            <!-- Action / checkbox column -->
            @if (tableInfo().showCheckbox || tableInfo().showIcon !== 'none') {
                <col style="width: 116px" />
            }
            
            <!-- Data columns -->
            @for (column of tableInfo().columns; track column; let i = $index) {
                <col [style.width.px]="columnWidths()[i]" />
            }
        </colgroup>
    </ng-template>

    <!-- BODY -->
    @if (enableStickyCols) {
        <ng-template pTemplate="body" let-item let-expanded="expanded">
            <tr class="row-clickable" (click)="onChildRowClickEvent(item)" [pSelectableRow]="item.id">
                <td pFrozenColumn class="expand-arrow-cell">
                    @if (item[tableInfo().expandableProp]) {
                        <p-button type="button" pRipple [pRowToggler]="item" [text]="true" severity="secondary" [rounded]="true"
                            (click)="onExpand($event, item, expanded)">
                            <i class="icon {{ expanded ? 'arrow-up-icon' : 'arrow-down-icon' }}"></i>
                        </p-button>
                    }
                </td>
                @if (tableInfo().showCheckbox || tableInfo().showIcon !== 'none') {
                    <td pFrozenColumn [style.width]="'116px'">
                        <div class="actions-cell">
                                @if (tableInfo().showCheckbox) {
                                    <div>
                                        <p-checkbox [inputId]="item.id" [name]="item.id" [ngModel]="getCheckboxState(item.id)" binary="true" (onChange)="onCheckboxChange(item, $event)"
                                            (click)="$event.stopPropagation()"></p-checkbox>
                                    </div>
                                }

                                <div>
                                    @if (tableInfo().showIcon === 'more') {
                                        <app-button [type]="'secondary'" [label]="''" [showIcon]="true" [iconClass]="'more-icon'"
                                            [extraClasses]="'btn-table'" (click)="onMoreClickEvent($event, item, moreMenu)"></app-button>
                                        <p-menu #moreMenu [model]="item.moreOptions" [popup]="true" appendTo="body" />
                                    }
                                    @else if (tableInfo().showIcon === 'edit') {
                                        <app-button [type]="'secondary'" [label]="''" [showIcon]="true" [iconClass]="'edit-icon'"
                                            [extraClasses]="'btn-table'" (clicked)="onEditClickEvent(item)" (click)="$event.stopPropagation()"></app-button>
                                    }
                                </div>

                            @if (item[tableInfo().expandableProp]) {
                                <i class="icon folder-icon"></i>
                            }
                        </div>
                    </td>
                }

                <!-- Regular Columns -->
                @for (column of tableInfo().columns; track column; let i = $index) {
                    @if(!column.hide && !column.customizeHide) {
                        @if(column.sticky) {
                            <td pFrozenColumn [ngClass]="column.wrapText ? 'text-wrap' : ''" [style.width.px]="columnWidths()[i]">
                                <div [innerHTML]="item[column.id] | translate"></div>
                            </td>
                        }
                        @else {
                            <td [ngClass]="column.wrapText ? 'text-wrap' : ''" [style.width.px]="columnWidths()[i]">
                                @if (column.displayType === 'status') {
                                    <div class="status" [ngClass]="item[column.id] | statusClass">
                                        {{ item[column.id] | translate }}
                                    </div>
                                }
                                @else if (column.displayType === 'chips') {
                                    <div class="tag-container">
                                        @for (data of item[column.id]; track data) {
                                        <p-tag class="tag-style-grey" value="{{data | translate}}" />
                                        }
                                    </div>
                                }
                                @else {
                                    <div [innerHTML]="item[column.id] | translate"></div>
                                }
                            </td>
                        }
                    }
                }
            </tr>
        </ng-template>
    }
    @else {
        <ng-template pTemplate="body" let-item let-expanded="expanded">
            <tr class="row-clickable" (click)="onChildRowClickEvent(item.id)">
                @if (tableInfo().type !== 'nested-alt') {
                    <td class="expand-arrow-cell">
                        @if (item[tableInfo().expandableProp]) {
                            <p-button type="button" pRipple [pRowToggler]="item" [text]="true" severity="secondary" [rounded]="true"
                                (click)="onExpand($event, item, expanded)">
                                <i class="icon {{ expanded ? 'arrow-up-icon' : 'arrow-down-icon' }}"></i>
                            </p-button>
                        }
                    </td>
                }
                @if (tableInfo().showCheckbox || tableInfo().showIcon !== 'none') {
                    <td [style.width]="'116px'">
                        <div class="actions-cell">
                            @if (tableInfo().showCheckbox) {
                                <div>
                                    <p-checkbox [inputId]="item.id" [name]="item.id" [ngModel]="getCheckboxState(item.id)" binary="true"
                                        (onChange)="onCheckboxChange(item, $event)" (click)="$event.stopPropagation()"></p-checkbox>
                                </div>
                            }

                            <div>
                                @if (tableInfo().showIcon === 'more') {
                                    <app-button [type]="'secondary'" [label]="''" [showIcon]="true" [iconClass]="'more-icon'"
                                        [extraClasses]="'btn-table'" (click)="onMoreClickEvent($event, item, moreMenu)"></app-button>
                                    <p-menu #moreMenu [model]="item.moreOptions" [popup]="true" appendTo="body" />
                                }
                                @else if (tableInfo().showIcon === 'edit') {
                                    <app-button [type]="'secondary'" [label]="''" [showIcon]="true" [iconClass]="'edit-icon'"
                                        [extraClasses]="'btn-table'" (clicked)="onEditClickEvent(item)"
                                        (click)="$event.stopPropagation()"></app-button>
                                }
                            </div>

                            @if (item[tableInfo().expandableProp]) {
                                <i class="icon folder-icon"></i>
                            }
                        </div>
                    </td>
                }

                <!-- Regular Columns -->
                @for (column of tableInfo().columns; track column; let i = $index) {
                    @if(!column.hide && !column.customizeHide) {
                        @if(column.sticky) {
                            <td pFrozenColumn [ngClass]="column.wrapText ? 'text-wrap' : ''" [style.width.px]="columnWidths()[i]">
                                {{ item[column.id] | translate }}
                            </td>
                        }
                        @else {
                            <td [ngClass]="column.wrapText ? 'text-wrap' : ''" [style.width.px]="columnWidths()[i]">
                                @if (column.displayType === 'status') {
                                    <div class="status" [ngClass]="item[column.id] | statusClass">
                                        {{ item[column.id] | translate }}
                                    </div>
                                }
                                @else if (column.displayType === 'chips') {
                                    <div class="tag-container">
                                        @for (data of item[column.id]; track data) {
                                        <p-tag class="tag-style-grey" value="{{data | translate}}" />
                                        }
                                    </div>
                                }
                                @else if (column.displayType === 'imageWithText') {
                                    <div class="td-image-with-text">
                                        <img src="assets/flags/MY.svg" />
                                        <span>{{item[column.id] | translate}}</span>
                                    </div>
                                }
                                @else {
                                    {{ item[column.id] | translate}}
                                }
                            </td>
                        }
                    }
                }
            </tr>
        </ng-template>
    }
    <!-- <ng-template pTemplate="body" let-item let-expanded="expanded">
        <tr  class="row-clickable" (click)="onChildRowClickEvent(item.id)">
            @for (column of columns(); track column) {
                @if (!column.hide) {
                    <td>{{ item[column.id] }}</td>
                }
            }
            @if (item.children?.length > 0) {
            <td>
                <button type="button" pButton pRipple [pRowToggler]="item"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    (click)="onExpand($event, item, expanded)"></button>
            </td>
            }
        </tr>
    </ng-template> -->

    <!-- EXPANDED ROW -->
    <ng-template pTemplate="expandedrow" let-item>
        @if (item.children?.length > 0) {
        <tr>
            <td [attr.colspan]="tableInfo().columns.length + 1" class="recursive-td">
                <!-- Recursive call -->
                <app-recursive-table [columnWidths]="columnWidths()" [moduleCode]="moduleCode()" [data]="item.children" [tableInfo]="tableInfo()" [checkboxStateMap]="checkboxStateMap()" (checkboxStateMapChange)="checkboxStateMap.set($event)" (onExpandClick)="emitExpand($event)" (onChildRowClick)="onChildRowClickEvent($event)" />
            </td>
        </tr>
        }
    </ng-template>
</p-table>